import { render, staticRenderFns } from "./AdminLogs.vue?vue&type=template&id=358077b7&scoped=true&"
import script from "./AdminLogs.vue?vue&type=script&lang=js&"
export * from "./AdminLogs.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogs.vue?vue&type=style&index=0&id=358077b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358077b7",
  null
  
)

export default component.exports